import { render } from "./LegacyTriggerConfirm.vue?vue&type=template&id=1000e0f0"
import script from "./LegacyTriggerConfirm.vue?vue&type=script&lang=js"
export * from "./LegacyTriggerConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script